/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useTranslation } from "react-i18next";
import ProductCarousel from "./ProductCarousel";
import ProductTitleVideo from "./ProductTitleVideo";
import ProductShare from "./ProductShare";
import ProductDesc from "./ProductDesc";
import SimilarProductsDynamic from "../common/SimilarProductsDynamic";

function CamasirSuyu() {
const [activeIndex, setActiveIndex] = useState(0);

const handleSelect = (selectedIndex) => {
setActiveIndex(selectedIndex);
};

const handlePrev = () => {
handleSelect(activeIndex === 0 ? 5 : activeIndex - 1);
};

const handleNext = () => {
handleSelect(activeIndex === 5 ? 0 : activeIndex + 1);
};

const { t } = useTranslation();

const [expanded, setExpanded] = useState(false);

const toggleNav = () => {
setExpanded(!expanded);
};

const handleClick = () => {
window.scrollTo(0, 0);
setExpanded(false);
};

const customProducts = [
{
"picture": "assets/images/20-kg/3.webp",
"nav": "/ultrakivamlicamasirsuyu",
"title": "Ultra Kıvamlı Ç. Suyu"
}
]

return (
<>
  <SRLWrapper>
    <section class="product-details section-space">
      <div class="container">
        <div class="row gutter-y-50">
          <div class="col-lg-6 col-xl-6 wow fadeInLeft" data-wow-delay="200ms">
            <div class="product-details__img">
              <div class="swiper product-details__gallery-top p-5">
                <div className="album-list-item">
                  <Link className="ali-link" onClick={handleClick} as={Link} to="/Armur">
                  <div className="ali-img-wrap">
                    <div>
                      <img className="img-fluid blur-up lazyload" src="assets/images/20-kg/2.webp" alt="image"
                        title="image" />
                    </div>
                  </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-6 wow fadeInRight" data-wow-delay="300ms">
            <div class="product-details__content">
              <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                <ProductTitleVideo title="Çamaşır Suyu" video="" />
                <span className="product-details__weight"
                  style={{fontSize: '16px', fontWeight: 'bold', color: '#10adad'}}>
                  5 KG - 20 KG
                </span>
              </div>
              <div class="product-details__excerpt">
                <h5 class="mt-4 mb-3">KULLANIM ŞEKLİ VE MİKTARI</h5>

                <h5 class="mt-3 mb-2">ELDE YIKAMA</h5>
                <ul class="product-details__list">
                  <li>Deterjan koymayınız. 15 lt soğuk suya 250 gr Dexpur ilave ederek çamaşırları bastırınız.</li>
                  <li>30 dakika bekledikten sonra bol su ile durulayınız. Deterjanı durulama yaptıktan sonra koyunuz.
                  </li>
                </ul>

                <h5 class="mt-3 mb-2">OTOMATİK MAKİNALARDA</h5>
                <ul class="product-details__list">
                  <li>Deterjan koymayınız. Beyaz çamaşırlarınız makineye doldurup, soğuk su ile kısa programı seçiniz.
                    Makine su alırken deterjanı koymadan 500 gr Dexpur'u deterjan gözüne dökünüz.</li>
                  <li>Durulama bittikten sonra düşük ısıda ve ön yıkamasız programda deterjan koyarak yıkama yapınız.
                  </li>
                </ul>

                <h5 class="mt-3 mb-2">NORMAL MAKİNALARDA</h5>
                <ul class="product-details__list">
                  <li>Deterjan koymayınız. Makinenizi soğuk su ile doldurup 500-700 gr Dexpur ilave ediniz.</li>
                  <li>Beyaz çamaşırlarınızı makineye doldurup 15-30 dakika yıkayınız. Sonra bu su ile durulayıp
                    gerekirse deterjanla tekrar yıkayınız.</li>
                </ul>

              </div>

              <div class="product-details__buttons">
                <Link as={Link} to="/urunlerimiz" class="product-details__btn boskery-btn">
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__text">
                  {" "}
                  DİĞER ÜRÜNLERİMİZ
                </span>
                <i class="icon-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-details__description-wrapper">
        <div class="container">
          <div class="product-details__description">
            <h3 class="product-details__description__title">
              Ürün detayları
            </h3>
            <div class="product-details__text__box wow fadeInUp" data-wow-delay="300ms">

              <h5 class="mt-3 mb-2">GENEL EV TEMİZLİĞİNDE</h5>
              <p class="product-details__description__text">
                Deterjan koymayınız. 15 lt suya 500 gr Dexpur ekleyerek mutfak zeminlerini, fayansları, banyo
                zeminlerini temizleyebilirsiniz.
                Tuvalet temizliğinde ise 15 lt suya 750-850 gr Dexpur ilave ederek genel temizlik yapılır. Gıda
                maddeleri tüzüğüne göre 40 misli su katıldıktan sonra yalnız bitkisel maddelerden yapılmış çamaşır
                beyazlatılmasında kullanılır.
              </p>

              <p class="product-details__description__text">
                Yünlü, ipekli, suni ipekli, mohair, renklere dayanıksız kumaşlar, rejenere selülozik lif, deri, gümüş ve
                alüminyum eşyalar üzerinde kullanılmaz.
                Alüminyum, çinko, kalay ve bunların alaşımlarıile temas ettirmeyiniz ve asitlerle (tuvalet
                temizleyiciler, kireç çözücüler vb) karıştırmayınız.
              </p>

              <div class="alert mt-4" style={{backgroundColor: '#10adad', color: 'white'}}>
                <h6><strong>TÜKETİCİNİN DİKKATİNE :</strong></h6>
                <ul class="mb-0" style={{paddingLeft: '20px'}}>
                  <li>Kullanma talimatını mutlaka okuyunuz.</li>
                  <li>El, yüz, vücut ve gıda maddeleri temizliğinde kullanmayınız.</li>
                  <li>Çocuklardan uzak tutunuz.</li>
                  <li>Direkt güneş ışığından koruyunuz.</li>
                  <li>Oda sıcaklığında muhafaza ediniz.</li>
                  <li>Kullandıktan sonra ellerinizi bol su ile yıkayınız.</li>
                  <li>TUZ RUHU, KEZZAP gibi asitli maddeler ile kesinlikle karıştırmayınız.</li>
                  <li>Zehirlenme durumunda Ulusal Zehir Danışma Merkezi'nin (UZEM) 114 no'lu telefonunu ve Acil Sağlık
                    Hizmetleri'nin 112 no'lu telefonunu arayınız.</li>
                </ul>
              </div>

              <div class="danger-warnings mt-4 p-3 bg-danger text-white">
                <h6><strong>⚠️ TEHLİKE UYARILARI:</strong></h6>
                <ul class="mb-3">
                  <li><strong>H290:</strong> Metaller için aşındırıcı olabilir.</li>
                  <li><strong>H314:</strong> Ciddi deri yanıklarına ve göz hasarına yol açar.</li>
                  <li><strong>H400:</strong> Sucul ortamda çok toksiktir.</li>
                </ul>

                <h6><strong>🛡️ GÜVENLİK TALİMATLARI:</strong></h6>
                <ul class="mb-3">
                  <li><strong>P260:</strong> Tozunu dumanını / gazını / sisini / buharını solumayınız.</li>
                  <li><strong>P271:</strong> Dışarıda ve iyi havalandrılan bir ortamda kullanınız.</li>
                  <li><strong>P280:</strong> Koruyucu eldiven/koruyucu kıyafet/göz koruyucu/yüz koruyucu kullanın.</li>
                  <li><strong>P301+P330+P331:</strong> YUTULDUĞUNDA: Ağzınızı çalkalayın. İstifra etmeye çalışmayın.
                  </li>
                  <li><strong>P303+P351+P338:</strong> DERİ (veya saç) İLE TEMAS HALİNDE İSE: Kirlenmiş tüm
                    giysilerinizi hemen kaldırın/çıkartın. Cildinizi su/duş ile durulayın.</li>
                  <li><strong>P305+P351+P338:</strong> GÖZ İLE TEMAS HALİNDE İSE: Su ile birkaç dakika durulayın. Takılı
                    ve yapması kolaysa kontakt lensleri çıkartın. Durulamaya devam edin.</li>
                  <li><strong>EDHO31 :</strong> Asitlerle temasında toksik gaz çıkarır.</li>
                  <li>Dexpur yanlış kullanım ve saklamadan doğacak zarardan sorumlu değildir.</li>
                </ul>

                <div class="alert alert-light mt-3 mb-0">
                  <p class="mb-2"><strong>EK BİLGİ:</strong> Sodyum hipoklorit içeren ürün.</p>
                  <p class="mb-0"><strong>NOT:</strong> Üretim tarihi, son kullanma tarihi ile parti no ve seri no,
                    ambalajın üzerindedir.</p>
                </div>
              </div>

              <div class="product-info-box mt-4 p-3 bg-light">
                <h6><strong>📋 TEKNİK BİLGİLER:</strong></h6>
                <div class="row">
                  <p><strong>Net Ağırlık:</strong> 5 KG ve 20 KG Seçenekleri mevcuttur.</p>
                  <p><strong>Üretici Firma :</strong> Seymen Kimya Temizlik San. ve Tic. Ltd. Şti.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </SRLWrapper>

  <SimilarProductsDynamic products={customProducts} handleClick={handleClick} />
</>
);
}

export default CamasirSuyu;